import React, {Fragment} from "react";

import { SmartErrorDiv } from "./SmartErrorDiv";

const FormTextarea = ( { register, width, readOnly = false, label, placeholder = null, sectionName, name, style, className, formErrors, maxLength, required, rows = 3} ) =>
{
    const classText = className === undefined ? "form-control" : '' ;

    return (
        <Fragment>
            <label className='col-form-label'>{label}</label>
            <textarea readOnly={readOnly} rows={rows} placeholder={placeholder}
                   className={classText} {...register(sectionName + '.' + name, {
                required: required,
                maxLength: maxLength
            })} />
            <SmartErrorDiv sectionName={sectionName}  name={name} maxLength={maxLength} formErrors={formErrors} />
        </Fragment>
    )
}

export { FormTextarea }
